export const SOFTWARE_LICENSE = 'SOFTWARE_LICENSE' as const;

export const FISCAL_MODEL_OPTIONS = [
  { label: 'Take rate', value: 'TAKE_RATE' },
  { label: 'Full service', value: 'FULL_SERVICE' },
  { label: 'Licença de software', value: SOFTWARE_LICENSE },
  { label: 'Simplifica', value: 'SIMPLIFICA' },
] as const;

export type FiscalModelValue =
  (typeof FISCAL_MODEL_OPTIONS)[number]['value'];
